import * as pdfjsLib from 'pdfjs-dist'
import pdfWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?worker&url'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker

// Renders page 1 of a PDF to a PNG blob so the canvas can show the actual page
// instead of a generic icon during upload and after reloads. The lazy `PdfPreview`
// still handles full multi-page navigation when the user interacts with the card.
//
// Scale 1.5 keeps text crisp at typical card sizes while staying small enough to
// upload quickly (~30–80 KB for a typical letter page).
export async function extractPdfThumbnail(file: File, scale = 1.5): Promise<Blob> {
  console.debug('[pdf-thumb] start', { name: file.name, size: file.size })
  const buffer = await file.arrayBuffer()
  const pdf = await pdfjsLib.getDocument({ data: buffer }).promise
  console.debug('[pdf-thumb] document opened', { pages: pdf.numPages })
  try {
    const page = await pdf.getPage(1)
    const viewport = page.getViewport({ scale })
    const canvas = document.createElement('canvas')
    canvas.width = viewport.width
    canvas.height = viewport.height
    const ctx = canvas.getContext('2d')
    if (!ctx) throw new Error('2D context unavailable')
    await page.render({ canvasContext: ctx, viewport, canvas }).promise
    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (b) => (b ? resolve(b) : reject(new Error('canvas.toBlob produced null'))),
        'image/png',
      )
    })
    console.debug('[pdf-thumb] rendered', { bytes: blob.size })
    return blob
  } finally {
    void pdf.destroy()
  }
}
